import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase';
import { User } from '../models/group';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(public fbAuth: AngularFireAuth, public userService: UserService) { }

  doEmailLogin(user: any) {
    return new Promise<any>((resolve, reject) => {
      this.fbAuth.auth.signInWithEmailAndPassword(user.email, user.password)
        .then(res => {
          resolve(res);
        }, err => reject(err)
        )
    })
  }

  doGoogleLogin() {
    return new Promise<any>((resolve, reject) => {
      let provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope('profile');
      provider.addScope('email');
      this.fbAuth.auth
        .signInWithPopup(provider)
        .then(res => {
          resolve(res);
        }, err => reject(err)
        )
    })
  }

  doEmailRegistration(user: User, pwd: string) {
    return new Promise<any>((resolve, reject) => {
      // register the user
      firebase.auth().createUserWithEmailAndPassword(user.email, pwd)
        .then(res => {
          user.id = res.user.uid;
          // add user to /users
          this.userService.add(user).then(res => {
            resolve(res);
          },
            err => reject(err));
        }, err => reject(err))
    })
  }

  getCurrentUser() {
    return new Promise<any>((resolve, reject) => {
      var user = firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          resolve(user);
        } else {
          reject('No user logged in');
        }
      })
    })
  }

  doLogout() {
    firebase.auth().signOut();
  }
}
